import React, { useMemo } from 'react';

import { Platform } from 'react-native';

import { useSelector } from 'react-redux';

import { NavigationContainer } from '@react-navigation/native';
import { Theme } from '@react-navigation/native/src/types';
import AppNavigator from 'router';

import { linkingOptions } from 'router/utils/linking';

import { selectBackground } from 'store/config/selectors.layout';

import useAccessibilitySettings from 'services/accessibility/hooks/useAccessibilitySettings';
import DidomiSDK from 'services/consents-management/DidomiSDK';
import useConsentSelectionChange from 'services/consents-management/DidomiSDK/hooks/useConsentSelectionChange';
import { DidomiRef } from 'services/consents-management/DidomiSDK/utils/createDidomiRef.ts';

import useAppState from 'utils/hooks/useAppState.ts';
import useRecordingsCache from 'utils/hooks/useRecordingsCache';
import { navigationRef } from 'utils/navigation/navigationUtils';

import GenericErrorDialog from 'screens/GenericErrorDialog';
import PlayerModal from 'screens/PlayerModal';
import SpotlightVideo from 'screens/Settings/SpotlightVideo';
import Splash from 'screens/Splash/index.web.tsx';
import TokenRefreshFailureModal from 'screens/TokenRefreshFailureModal';

import CastPinDialog from 'components/CastPinDialog';
import EmbeddedPlayerModalPortal from 'components/EmbeddedPlayer/components/EmbeddedPlayerModalPortal';
import SuspensionAlert from 'components/SuspensionAlert';
import VitalErrorDialog from 'components/VitalErrorDialog';

import useWindowResizeRedirect from './hooks/useWindowResizeRedirect';

const NavigatorContainer = () => {
    const backgroundColor = useSelector(selectBackground);

    const navigationContainerTheme = useMemo(() => {
        return { colors: { background: backgroundColor } } as Theme;
    }, []);

    useAppState();
    useWindowResizeRedirect();
    useAccessibilitySettings();
    useRecordingsCache();
    useConsentSelectionChange();

    return (
        <NavigationContainer
            ref={navigationRef}
            theme={navigationContainerTheme}
            linking={linkingOptions}
            documentTitle={{
                formatter: () => 'OneTV',
            }}
        >
            <AppNavigator />
            <PlayerModal />
            <SpotlightVideo />
            <EmbeddedPlayerModalPortal />
            <TokenRefreshFailureModal />
            <GenericErrorDialog />
            <VitalErrorDialog />
            <SuspensionAlert />
            <DidomiSDK ref={DidomiRef} />
            {Platform.OS === 'web' && <Splash />}
            {Platform.OS === 'android' && <CastPinDialog />}
        </NavigationContainer>
    );
};

export default NavigatorContainer;
